import React, { memo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { TextField, makeStyles } from '@material-ui/core'
import { ONLY_INTEGER_PATTERN } from 'constants/regExps'

const useStyles = makeStyles({
  input: {
    maxWidth: 100,
  },
})

function JobsWorkflowAdminPositionChange({ position, onChange }) {
  const [value, setValue] = useState(position)
  const styles = useStyles()

  useEffect(() => {
    if (position !== null && position !== value) {
      setValue(position)
    }
  }, [position])

  const handleValueChange = ({ target: { value } }) => {
    const valueIsEmpty = value === ''

    if (ONLY_INTEGER_PATTERN.test(value) || valueIsEmpty) {
      setValue(valueIsEmpty ? value : +value)
    }
  }

  const handleValueSave = () => {
    if (ONLY_INTEGER_PATTERN.test(String(value)) && value !== position) {
      onChange(value)
    }
  }

  return (
    <TextField
      value={value}
      className={styles.input}
      onChange={handleValueChange}
      onBlur={handleValueSave}
    />
  )
}

JobsWorkflowAdminPositionChange.propTypes = {
  position: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default memo(JobsWorkflowAdminPositionChange)
